import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as l } from "../../../../IconBase-CxZyIWw2.js";
const t = a((e, o) => /* @__PURE__ */ s.jsx(
  l,
  {
    ref: o,
    ...e,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3492",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "m13.02 2.94-.12-.1C10.37.72 9.52 0 8.01 0c-1.45 0-2.35.77-4.5 2.62l-.32.27C1.34 4.48 0 5.62 0 7.75v7.5c0 .41.34.75.75.75s.75-.34.75-.75v-7.5c0-1.38.77-2.1 2.66-3.72l.32-.28C6.57 1.97 7.15 1.5 8.01 1.5c.92 0 1.53.48 3.92 2.49l.12.1c2.14 1.8 2.45 2.42 2.45 3.78v7.38c0 .41.34.75.75.75s.75-.34.75-.75V7.87c0-2.06-.78-3.08-2.98-4.93"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3492)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
t.displayName = "AgencyHomeIcon";
export {
  t as AgencyHomeIcon,
  t as default
};
//# sourceMappingURL=index.js.map
